import { ChangeDetectorRef, OnChanges } from "@angular/core";

import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { GridsterService } from "src/app/services/gridster.service";
import { Subject } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { SelectedOrderTradeComponent } from "../selected-order-trade/selected-order-trade.component";

@Component({
  selector: "app-trades-order-history",
  templateUrl: "./trades-order-history.component.html",
  styleUrls: ["./trades-order-history.component.scss"],
})
export class TradesOrderHistoryComponent implements OnInit {
  rows = [];

  DataToShow = false;
  ColumnMode = ColumnMode;
  dtTrigger: Subject<any> = new Subject<any>();

  @Input() orderRequest: any[] = [];
  @Input() marketList: any;
  @Input() typesList: any;
  @Input() statusList: any;
  dtOptions: {
    // scrollX: true,
    paging: boolean;
    searching: boolean;
    autoWidth: boolean;
    info: boolean;
    responsive: boolean;
    fixedHeader: boolean;
    select: boolean;
    order: any;
    sorting: any[];
  };
  mapFixStatusColor = new Map([
    ["0", "#007bff"],
    ["1", "#5aff55"],
    ["2", "darkgreen"],
    ["3", "yellow"],
    ["4", "#ff7200"],
    ["5", "#550eff"],
    ["6", "yellow"],
    ["8", "darkred"],
    ["9", "gray"],
    ["A", "yellow"],
    ["C", "darkred"],
    ["E", "yellow"],
    ["H", "darkred"],
    ["N", "darkred"],
    ["R", "yellow"],
    ["W", "yellow"],
    ["P", "yellow"],
    ["X", "yellow"],
    ["Y", "darkred"],
    ["Z", "cyan"],
  ]);

  getBackgroundColor(fixStatusCode) {
    if (fixStatusCode) {
      let backgroundColor = this.mapFixStatusColor.get(fixStatusCode);
      return backgroundColor;
    }
  }
  getColor(fixStatusCode) {
    if (fixStatusCode) {
      let colorMatch = this.mapFixStatusColor.get(fixStatusCode);
      if (
        colorMatch == "white" ||
        colorMatch == "#5aff55" ||
        colorMatch == "yellow" ||
        colorMatch == "#ff7200" ||
        colorMatch == "darkred" ||
        colorMatch == "darkgreen" ||
        colorMatch == "cyan"||
        colorMatch == "#007bff"
      ) {
        return "white";
      }
    }
  }
  getTransaction(value) {
    if (value != null) {
      if (this.translate.currentLang == "en") {
        return this.typesList.find((x) => x.TransactionId == value)
          .TransactionNameE;
      } else {
        return this.typesList.find((x) => x.TransactionId == value)
          .TransactionTypeA;
      }
    }
  }

  // getTiffFlag(value) {
  //   return this.tiffFlagValue.find((x) => x.value == value).viewValue;
  // }
  getStatus(value) {
    if (value != null) {
      if (this.translate.currentLang == "en") {
        return this.statusList.find((x) => x.Id == value).NameE;
      } else {
        return this.statusList.find((x) => x.Id == value).NameA;
      }
    }
  }

  constructor(
    public translate: TranslateService,
    public snackBar: MatSnackBar,
    private _gridService: GridsterService,
    public dialog: MatDialog,
    private _service: ApiService,
    private changeDetector: ChangeDetectorRef
  ) {}

  isDate(prop) {
    return prop == "TiffDate";
  }
  isNum(prop) {
    return prop == "OrgPrice";
  }
  isSymbol(prop) {
    return prop == "SymbolShortNameEn";
  }
  isPriceType(prop) {
    return prop == "IsMarketPrice";
  }
  isLastDate(prop) {
    return prop == "lastTradeTime";
  }
  isCustdCode(name) {
    return name == "custodianCode";
  }
  isCustdName(name) {
    return name == "custodian-name";
  }
  isTransaction(prop) {
    return prop == "TransactionTypeEn";
  }
  isStatus(prop) {
    return prop == "FixStatusEn";
  }

  ngOnInit(): void {
    if (this._gridService.getOrderHistoryColumns())
      this.columns = this._gridService.getOrderHistoryColumns();
    else this.columns = this.allFilters;

    this.dtTrigger.next();
    this.WindowResize();

    this.dtOptions = {
      // scrollX: true,
      paging: false,
      searching: false,
      autoWidth: true,
      info: false,
      responsive: true,
      fixedHeader: true,
      select: false,
      order: [[4, "desc"]],
      sorting: [],
      // ajax: (dataTablesParameters: any, callback) => {
      //   this.fetchEGX("EGX30").subscribe((res) => {
      //     this.isCompaniesLoading = false;
      //     this.companies = res as CompanyList[];
      //     this.WindowResize();

      //     callback({
      //       recordsTotal: this.companies.length,
      //       data: [],
      //     });
      //   });
      // },
    };
  }
  allFilters = [
    { prop: "FixStatusEn", name: "status", isChecked: true },
    { prop: "SymbolShortNameEn", name: "symbolCode", isChecked: true },
    { prop: "OrderNumber", name: "#order", isChecked: true },
    { prop: "lastTradeTime", name: "Last-update", isChecked: true },
    { prop: "TransactionTypeEn", name: "order-type", isChecked: true },
    { prop: "OrgQty", name: "qty", isChecked: true },
    { prop: "OrgPrice", name: "price", isChecked: true },
    { prop: "TradedQty", name: "filled", isChecked: true },
    { prop: "IsMarketPrice", name: "price-type", isChecked: true },
    { prop: "TiffDate", name: "duration", isChecked: true },
    { prop: "MarketCode", name: "market", isChecked: false },
    { prop: "Reuters", name: "reuters", isChecked: false },
    { prop: "Custodian", name: "custodianCode", isChecked: false },
    { prop: "Custodian", name: "custodian-name", isChecked: false },
    { prop: "MinFillVolume", name: "min-fill-volume", isChecked: false },
    { prop: "Remark", name: "remark", isChecked: false },
    { prop: "AvgPrice", name: "average-price", isChecked: false },
    { prop: "FixText", name: "fix-text", isChecked: false },
    { prop: "MCSDText", name: "mcsd-text", isChecked: false },
    { prop: "IsSuspended", name: "suspended", isChecked: false },
    { prop: "MarketAvgPrice", name: "market-avg-price", isChecked: false },
  ];
  columns = [];

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.columns, event.previousIndex, event.currentIndex);
    this.updateCols();
  }
  updateCols() {
    this._gridService.saveOrderHistoryColumns(this.columns);

    this.WindowResize();
  }
  WindowResize() {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 250);
  }
  toggle(col, event) {
    col.isChecked = !col.isChecked;
    this.WindowResize();
    this.updateCols();
  }
  get colsss() {
    return this.columns.filter((col) => col.isChecked);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.orderRequest != null && changes.orderRequest != null) {
      if (
        changes.orderRequest.currentValue != changes.orderRequest.previousValue
      ) {
        this.DataToShow = true;
        this.orderRequest = changes.orderRequest.currentValue;
      } else {
        this.DataToShow = false;
      }
    } else {
      this.DataToShow = false;
    }
  }

  viewOrder(orderNum) {
    const dialogRef = this.dialog.open(SelectedOrderTradeComponent, {
      panelClass: "custom-dialog-container",
      data: { order: orderNum },
      width: "464px",
      direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
    });
    dialogRef.afterClosed().subscribe(() => {});
  }
}
